<template>
  <div class="br-jobs__form">
    <div
      v-if="submitted"
      class="notice notice--success">
      <div class="notice__content">
        <p>Your message has been successfully sent. Someone from our team will contact you shortly.</p>
      </div>
    </div>

    <form
      v-if="!submitted"
      method="POST"
      class="form"
      @submit.prevent="submit">
      <div class="row">
        <div class="six columns">
          <form-text
            v-model="model.first_name"
            :rules="['required']"
            label="First Name"
            name="first_name"/>
        </div>
        <div class="six columns">
          <form-text
            v-model="model.last_name"
            :rules="['required']"
            label="Last Name"
            name="last_name"/>
        </div>
      </div>
      <div class="row">
        <div class="six columns">
          <form-text
            v-model="model.phone_number"
            :rules="['required']"
            label="Phone"
            name="phone"/>
        </div>
        <div class="six columns">
          <form-text
            v-model="model.email_address"
            :rules="['required', 'email']"
            label="Email"
            name="email"/>
        </div>
      </div>
      <div class="row">
        <div class="twelve columns">
          <form-text
            v-model="model.address"
            :rules="['required']"
            label="Address"
            name="address"/>
        </div>
      </div>
      <div class="row">
        <div class="twelve columns">
          <form-file
            v-model="model.resume"
            :rules="['required', 'size:5120', 'mimes:application/pdf']"
            label="Attach Resume"
            name="resume"/>
        </div>
      </div>
      <div class="row">
        <div class="twelve columns">
          <form-file
            v-model="model.cover"
            :rules="['required', 'size:5120', 'mimes:application/pdf']"
            label="Attach Cover Letter"
            name="cover"/>
        </div>
      </div>
      <div class="row">
        <div class="twelve columns">
          <form-textarea
            v-model="model.notes"
            :rules="['required', 'min:10']"
            label="How'd you heard about us?"
            name="notes"/>
        </div>
      </div>
      <div class="row">
        <div class="twelve columns">
          <button
            id="career-form"
            :disabled="errors.any()"
            class="button u-border-radius u-pos-right">
            Submit Application
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import forOwn from 'lodash/forOwn'

export default {
  props: {
    job: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    submitted: false,
    model: {
      first_name: null,
      last_name: null,
      phone_number: null,
      email_address: null,
      address: null,
      cover: null,
      job_id: null,
      resume: null,
      notes: null
    }
  }),
  created () {
    this.model.job_id = this.job.job_id
  },
  methods: {
    getModelAsFormData () {
      const formData = new FormData()

      forOwn(this.model, (value, key) => {
        if (value) {
          formData.append(key, value)
        }
      })

      return formData
    },
    async submit () {
      const results = await this.$validator.validateAll()

      if (results) {
        await axios.post(this.route('jobs-submit'), this.getModelAsFormData())

        this.submitted = true
      }
    }
  }
}
</script>
